import { useState } from 'react'

/**
 * Imagen con marco de degradado a la espera de las fotos reales, que también
 * cubre el caso de una URL rota en producción para que nunca se muestre el
 * icono de imagen partida del navegador. Compartida entre la tarjeta del
 * catálogo y la galería del detalle de producto.
 */
function ImagenConFallback({ src, alt, className = '', prioridad = false, onClick }) {
  const [fallo, setFallo] = useState(!src)

  if (fallo) {
    return (
      <div
        className={`flex items-center justify-center bg-linear-to-br from-leopardo to-carbon ${className}`}
        role="img"
        aria-label={alt ? `Imagen pendiente de ${alt}` : 'Imagen pendiente'}
        onClick={onClick}
      >
        <span className="text-[0.65rem] uppercase tracking-[0.25em] text-oro-profundo">
          Imagen pendiente
        </span>
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setFallo(true)}
      onClick={onClick}
      loading={prioridad ? 'eager' : 'lazy'}
      fetchPriority={prioridad ? 'high' : 'auto'}
      decoding="async"
      className={className}
    />
  )
}

export default ImagenConFallback
